import LayerHeader from './LayerHeader'

export default LayerHeader



// WEBPACK FOOTER //
// ./src/components/LayerHeader/index.js